// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-light: #FFFFFF;
  --color-dark: #212121;
  --color-signal: #6aa50b;
  --color-shadow: #97cf3b;
  --color-marrom-black: #333333;
  --size-bezel: .5rem;
  --size-radius: 4px;
  --colorTituloTotal : #000000;
  --blackTotalVenda-color: #FFFFFF;
  }

  .tipoPagVendedora{
      line-height: 1.4;
      font-family: 'Inter', sans-serif;
      font-size: calc(.6rem + .4vw);
      color: var(--color-dark);
      background: var(--color-light);
      /* background-image: url('../imgs/fundoEsqAzul.png'); */
      font-weight: 300;
      background-size: cover;
  }

.tipoPagVendedora h1, .tipoPagVendedora h2, .tipoPagVendedora h3 {
font-weight: 900;
}

.tipoPagVendedora mark {
  background: var(--color-signal);
  color: var(--color-light);
  font-weight: bold;
  padding: 0 0.2em;
}

.tipoPagVendedora .card {
  min-width: 50%;
  background: var(--color-marrom-black);
  padding: 0.3% 2% 2% 2%;
  margin: 1% auto;
  margin-top: calc(4 * .5rem);
  border-radius: var(--size-radius);
  border: 3px solid var(--azulthink, currentColor);
  box-shadow: .5rem .5rem 0 var(--azulthink, currentColor);
  color: var(--color-light);
}


.tipoPagVendedora .button-group {
margin-top: calc(.5rem * 2.5);
}

.tipoPagVendedora .card button {
color: currentColor;
padding: .5rem calc(.5rem * 2);
background: var(--azulthink);
border: none;
border-radius: var(--size-radius);
font-weight: 900;

&[type=reset]{
background: var(--color-light);
font-weight: 200;
} 
}

.tipoPagVendedora .card button + button {
margin-left: calc(.5rem * 2);
}

.tipoPagVendedora .card button:hover {
  background-color: #0d59a5;
  cursor: pointer;
}

.tipoPagVendedora .icon {
display: inline-block;
width: 1em; height: 1em;
margin-right: .5em;
}

.tipoPagVendedora .hidden {
display: none;
}


.tipoPagVendedora .inputsCard{
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

.tipoPagVendedora .inputTitleComp{
  display: flex;
  flex-direction: column;
  width: fit-content;
  margin: 10px 10px;
}



.tipoPagVendedora .inputTitleComp input {
  background-color: var(--white-color);
  width: fit-content;
  margin-bottom: 3%;
  color: #000000;
  font-size: 15px;
  border-radius: 7px;
  padding: 10px;
  border: 1.5px solid #dededf;
}

.tipoPagVendedora .inputTitleComp input:is(:focus, :hover){
  border-color: rgba(100, 234, 118, 0.4);
  background-color: #fff;
  box-shadow: 0 0 0 4px #64eaa71a;
  outline: none;
}



.tipoPagVendedora .tablePagVendedoras {
  max-width: 80%;
  border-collapse: collapse;
  margin: 20px auto;
  color: var(--color-dark);
}

.tipoPagVendedora .tablePagVendedoras th, .tipoPagVendedora .tablePagVendedoras td {
  border: 2px solid #380808;
  padding: 8px;
  text-align: left;
}

.tipoPagVendedora .tablePagVendedoras th {
  background-color: #f2f2f2;
  text-align: center;
  color: var(--color-dark);
}

.tipoPagVendedora .tablePagVendedoras tr:nth-child(even) {
  background-color: #e7e7e7;
}

.custom-dialog {
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 1000;
}

.tipoPagVendedora .navbar {
  min-width: 100vw;
}

/* GRAFICO */
.tipoPagVendedora .graficoTotal{
  margin: 0 auto;
}


.tipoPagVendedora .totalPorcentagem{
  width: 100%;
  margin-top: 40px;
  text-align: center;
  font-size: 1.5em;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
}


.tipoPagVendedora .totalPorcentagem .naMeta{
  color: var(--medio-azul-color);
}

.tipoPagVendedora .totalPorcentagem .foraMeta{
  color: var(--vermelho-tipoPag);
}

@media (max-width: 767px){

  .tipoPagVendedora h2 {
    text-align: center;
  }

  .tipoPagVendedora .card {
      max-width: 95%;
  }

  .tipoPagVendedora .inputsCard {
    flex-direction: column;
    align-items: center;
  }

  .tipoPagVendedora .inputsCard .inputTitleComp{
    align-items: center;
  }

  .tipoPagVendedora .button-group{
    display: flex;
    margin-bottom: 10px;
  }

  .tipoPagVendedora .card h2{
    font-size: 1.5em;
  }

  .tipoPagVendedora .tablePagVendedoras th,
  .tipoPagVendedora .tablePagVendedoras td {
    font-size: 0.8em;
    font-weight: 700;
  }


}`, "",{"version":3,"sources":["webpack://./src/assets/css/tipoPagVendedora.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,gCAAgC;EAChC;;EAEA;MACI,gBAAgB;MAChB,gCAAgC;MAChC,6BAA6B;MAC7B,wBAAwB;MACxB,8BAA8B;MAC9B,uDAAuD;MACvD,gBAAgB;MAChB,sBAAsB;EAC1B;;AAEF;AACA,gBAAgB;AAChB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,iCAAiC;EACjC,gDAAgD;EAChD,wDAAwD;EACxD,yBAAyB;AAC3B;;;AAGA;AACA,6BAA6B;AAC7B;;AAEA;AACA,mBAAmB;AACnB,8BAA8B;AAC9B,4BAA4B;AAC5B,YAAY;AACZ,iCAAiC;AACjC,gBAAgB;;AAEhB;AACA,8BAA8B;AAC9B,gBAAgB;AAChB;AACA;;AAEA;AACA,4BAA4B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;AACA,qBAAqB;AACrB,UAAU,EAAE,WAAW;AACvB,kBAAkB;AAClB;;AAEA;AACA,aAAa;AACb;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;;;AAIA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;EAEtB,+BAA+B;EAC/B,aAAa;AACf;;;;AAIA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,cAAc;AAChB;;;AAGA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;;AAGA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE;IACE,kBAAkB;EACpB;;EAEA;MACI,cAAc;EAClB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;;;AAGF","sourcesContent":[":root {\r\n  --color-light: #FFFFFF;\r\n  --color-dark: #212121;\r\n  --color-signal: #6aa50b;\r\n  --color-shadow: #97cf3b;\r\n  --color-marrom-black: #333333;\r\n  --size-bezel: .5rem;\r\n  --size-radius: 4px;\r\n  --colorTituloTotal : #000000;\r\n  --blackTotalVenda-color: #FFFFFF;\r\n  }\r\n\r\n  .tipoPagVendedora{\r\n      line-height: 1.4;\r\n      font-family: 'Inter', sans-serif;\r\n      font-size: calc(.6rem + .4vw);\r\n      color: var(--color-dark);\r\n      background: var(--color-light);\r\n      /* background-image: url('../imgs/fundoEsqAzul.png'); */\r\n      font-weight: 300;\r\n      background-size: cover;\r\n  }\r\n\r\n.tipoPagVendedora h1, .tipoPagVendedora h2, .tipoPagVendedora h3 {\r\nfont-weight: 900;\r\n}\r\n\r\n.tipoPagVendedora mark {\r\n  background: var(--color-signal);\r\n  color: var(--color-light);\r\n  font-weight: bold;\r\n  padding: 0 0.2em;\r\n}\r\n\r\n.tipoPagVendedora .card {\r\n  min-width: 50%;\r\n  background: var(--color-marrom-black);\r\n  padding: 0.3% 2% 2% 2%;\r\n  margin: 1% auto;\r\n  margin-top: calc(4 * .5rem);\r\n  border-radius: var(--size-radius);\r\n  border: 3px solid var(--azulthink, currentColor);\r\n  box-shadow: .5rem .5rem 0 var(--azulthink, currentColor);\r\n  color: var(--color-light);\r\n}\r\n\r\n\r\n.tipoPagVendedora .button-group {\r\nmargin-top: calc(.5rem * 2.5);\r\n}\r\n\r\n.tipoPagVendedora .card button {\r\ncolor: currentColor;\r\npadding: .5rem calc(.5rem * 2);\r\nbackground: var(--azulthink);\r\nborder: none;\r\nborder-radius: var(--size-radius);\r\nfont-weight: 900;\r\n\r\n&[type=reset]{\r\nbackground: var(--color-light);\r\nfont-weight: 200;\r\n} \r\n}\r\n\r\n.tipoPagVendedora .card button + button {\r\nmargin-left: calc(.5rem * 2);\r\n}\r\n\r\n.tipoPagVendedora .card button:hover {\r\n  background-color: #0d59a5;\r\n  cursor: pointer;\r\n}\r\n\r\n.tipoPagVendedora .icon {\r\ndisplay: inline-block;\r\nwidth: 1em; height: 1em;\r\nmargin-right: .5em;\r\n}\r\n\r\n.tipoPagVendedora .hidden {\r\ndisplay: none;\r\n}\r\n\r\n\r\n.tipoPagVendedora .inputsCard{\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.tipoPagVendedora .inputTitleComp{\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: fit-content;\r\n  margin: 10px 10px;\r\n}\r\n\r\n\r\n\r\n.tipoPagVendedora .inputTitleComp input {\r\n  background-color: var(--white-color);\r\n  width: fit-content;\r\n  margin-bottom: 3%;\r\n  color: #000000;\r\n  font-size: 15px;\r\n  border-radius: 7px;\r\n  padding: 10px;\r\n  border: 1.5px solid #dededf;\r\n}\r\n\r\n.tipoPagVendedora .inputTitleComp input:is(:focus, :hover){\r\n  border-color: rgba(100, 234, 118, 0.4);\r\n  background-color: #fff;\r\n  -webkit-box-shadow: 0 0 0 4px #64ea8c1a;\r\n  box-shadow: 0 0 0 4px #64eaa71a;\r\n  outline: none;\r\n}\r\n\r\n\r\n\r\n.tipoPagVendedora .tablePagVendedoras {\r\n  max-width: 80%;\r\n  border-collapse: collapse;\r\n  margin: 20px auto;\r\n  color: var(--color-dark);\r\n}\r\n\r\n.tipoPagVendedora .tablePagVendedoras th, .tipoPagVendedora .tablePagVendedoras td {\r\n  border: 2px solid #380808;\r\n  padding: 8px;\r\n  text-align: left;\r\n}\r\n\r\n.tipoPagVendedora .tablePagVendedoras th {\r\n  background-color: #f2f2f2;\r\n  text-align: center;\r\n  color: var(--color-dark);\r\n}\r\n\r\n.tipoPagVendedora .tablePagVendedoras tr:nth-child(even) {\r\n  background-color: #e7e7e7;\r\n}\r\n\r\n.custom-dialog {\r\n  display: none;\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  padding: 20px;\r\n  background-color: #fff;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\r\n  z-index: 1000;\r\n}\r\n\r\n.tipoPagVendedora .navbar {\r\n  min-width: 100vw;\r\n}\r\n\r\n/* GRAFICO */\r\n.tipoPagVendedora .graficoTotal{\r\n  margin: 0 auto;\r\n}\r\n\r\n\r\n.tipoPagVendedora .totalPorcentagem{\r\n  width: 100%;\r\n  margin-top: 40px;\r\n  text-align: center;\r\n  font-size: 1.5em;\r\n  font-family: 'Inter', sans-serif;\r\n  font-weight: 500;\r\n}\r\n\r\n\r\n.tipoPagVendedora .totalPorcentagem .naMeta{\r\n  color: var(--medio-azul-color);\r\n}\r\n\r\n.tipoPagVendedora .totalPorcentagem .foraMeta{\r\n  color: var(--vermelho-tipoPag);\r\n}\r\n\r\n@media (max-width: 767px){\r\n\r\n  .tipoPagVendedora h2 {\r\n    text-align: center;\r\n  }\r\n\r\n  .tipoPagVendedora .card {\r\n      max-width: 95%;\r\n  }\r\n\r\n  .tipoPagVendedora .inputsCard {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n\r\n  .tipoPagVendedora .inputsCard .inputTitleComp{\r\n    align-items: center;\r\n  }\r\n\r\n  .tipoPagVendedora .button-group{\r\n    display: flex;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .tipoPagVendedora .card h2{\r\n    font-size: 1.5em;\r\n  }\r\n\r\n  .tipoPagVendedora .tablePagVendedoras th,\r\n  .tipoPagVendedora .tablePagVendedoras td {\r\n    font-size: 0.8em;\r\n    font-weight: 700;\r\n  }\r\n\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
